/* Diamond search — vanbruun-style faceted search over our synced catalogue.
   Data via Shopify App Proxy → bridge API (/apps/diamonds/search). The page is
   noindex; this is a UX surface, not an SEO one. Vanilla JS, no deps. */
(function () {
  var root = document.querySelector('[data-dsearch]');
  if (!root) return;

  var PROXY = (root.getAttribute('data-proxy') || '/apps/diamonds').replace(/\/$/, '');
  // Preset filters for pre-scoped mounts (collection pages). Either an explicit
  // query string in data-preset, or derived from data-preset-handle via the shared
  // handle parser. The URL always wins over the preset, and "Clear all" returns to
  // the preset rather than to an empty search, so a Round collection stays Round.
  var PRESET = (function () {
    var explicit = root.getAttribute('data-preset');
    var p = new URLSearchParams(explicit || '');
    var handle = root.getAttribute('data-preset-handle');
    if (!explicit && handle && window.vaalbergHandleFilters) {
      var f = window.vaalbergHandleFilters(handle);
      Object.keys(f).forEach(function (k) { p.set(k, f[k]); });
      // cut=EX only on Round-only scopes: without a shape it drops every fancy shape.
      if (f.shape === 'ROUND' && root.getAttribute('data-cut-ex') !== 'false') p.set('cut', 'EX');
    }
    // "Featured" window (data-featured, query-string style, e.g. "caratMin=1.5&caratMax=3"):
    // the default scope of a clean landing, so the first page shows the stones the
    // store wants to lead with instead of the cheapest 0.3 ct. Fills only the keys the
    // scope does not set itself — a carat collection keeps its own band — and behaves
    // like the rest of the preset: the slider shows it, the URL overrides it, and
    // "Clear all" returns to it.
    var featured = root.getAttribute('data-featured');
    if (featured) {
      var scopeHasBand = p.has('caratMin') || p.has('caratMax'); // the band is one thing: a scope with a min keeps its open max
      new URLSearchParams(featured).forEach(function (v, k) {
        if (/^carat(Min|Max)$/.test(k) && scopeHasBand) return;
        if (!p.has(k)) p.set(k, v);
      });
    }
    return p;
  })();
  // Locale-aware product URLs: on /sv-se/ Shopify.routes.root is "/sv-se/".
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  function productUrl(u) { return u ? ROOT + u : u; }
  var PAGE_SIZE = 20;
  var MULTI = ['shape', 'color', 'clarity', 'cut', 'lab', 'fluor'];
  var RANGE = ['caratMin', 'caratMax', 'priceMin', 'priceMax'];

  var els = {
    results: root.querySelector('[data-results]'),
    count: root.querySelector('[data-count]'),
    pagination: root.querySelector('[data-pagination]'),
    sort: root.querySelector('[data-sort]'),
    loading: root.querySelector('[data-loading]'),
    empty: root.querySelector('[data-empty]'),
    filters: root.querySelector('[data-filters]'),
    toggle: root.querySelector('[data-filter-toggle]'),
    caratMin: root.querySelector('[data-carat-min]'),
    caratMax: root.querySelector('[data-carat-max]'),
    priceMin: root.querySelector('[data-price-min]'),
    priceMax: root.querySelector('[data-price-max]'),
    facets: {
      shape: root.querySelector('[data-facet="shape"]'),
      color: root.querySelector('[data-facet="color"]'),
      clarity: root.querySelector('[data-facet="clarity"]'),
      cut: root.querySelector('[data-facet="cut"]'),
      lab: root.querySelector('[data-facet="lab"]'),
      fluor: root.querySelector('[data-facet="fluor"]')
    }
  };

  var state = readURL();

  function readURL() {
    var p = new URLSearchParams(PRESET.toString());
    new URLSearchParams(location.search).forEach(function (v, k) { p.set(k, v); });
    var s = {
      page: parseInt(p.get('page') || '1', 10) || 1,
      sort: p.get('sort') || 'featured',
      view: p.get('view') === 'grid' ? 'grid' : 'list' // list is the default
    };
    MULTI.forEach(function (d) { var v = p.get(d); s[d] = v ? v.split(',').filter(Boolean) : []; });
    RANGE.forEach(function (k) { var v = p.get(k); s[k] = (v !== null && v !== '') ? v : null; });
    return s;
  }

  function buildParams(forUrl) {
    var p = new URLSearchParams();
    MULTI.forEach(function (d) { if (state[d] && state[d].length) p.set(d, state[d].join(',')); });
    RANGE.forEach(function (k) { if (state[k] != null && state[k] !== '') p.set(k, state[k]); });
    if (!forUrl || state.sort !== 'featured') p.set('sort', state.sort);
    if (!forUrl || state.page > 1) p.set('page', state.page);
    if (!forUrl) p.set('pageSize', PAGE_SIZE);
    if (forUrl && state.view === 'grid') p.set('view', 'grid'); // list is default; only persist grid
    return p;
  }

  // When the page opened on a clean URL, the first written state IS the preset
  // (after slider/step normalisation). Keep the URL clean until it changes, so a
  // collection page does not grow ?shape=ROUND on load. A deep link (URL with
  // params) is never stripped.
  // Params the search does not own (e.g. Shopify's ?view=diamond template switch)
  // are carried through untouched, so a reload keeps the user's template.
  var FOREIGN = (function () {
    var f = new URLSearchParams(), owned = {};
    MULTI.concat(RANGE, ['sort', 'page']).forEach(function (k) { owned[k] = 1; });
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (owned[k] || k === 'stone' || (k === 'view' && v === 'grid')) return;
      f.set(k, v);
    });
    return f;
  })();
  // ?stone=<id> is owned by the quick-view panel (diamond-quickview.js), not by the search.
  var CLEAN_START = (function () {
    var cur = new URLSearchParams(location.search); cur.delete('stone');
    return FOREIGN.toString() === cur.toString();
  })(), INITIAL_QS;
  function writeURL() {
    var qs = buildParams(true).toString();
    if (CLEAN_START && INITIAL_QS === undefined) INITIAL_QS = qs;
    if (CLEAN_START && qs === INITIAL_QS) qs = '';
    var merged = new URLSearchParams(FOREIGN.toString());
    new URLSearchParams(qs).forEach(function (v, k) { merged.set(k, v); });
    var openStoneId = new URLSearchParams(location.search).get('stone');
    if (openStoneId) merged.set('stone', openStoneId);
    qs = merged.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  // Debounce rapid filter taps (multi-select) into ONE request, and dim the
  // current results instantly so every tap has immediate visual feedback.
  var loadTimer = null;
  function scheduleLoad() {
    if (els.results) els.results.classList.add('is-filtering');
    clearTimeout(loadTimer);
    loadTimer = setTimeout(load, 400);
  }

  var inflight = null;
  function load() {
    if (els.results) els.results.classList.add('is-filtering');
    if (els.loading) els.loading.hidden = false;
    writeURL();
    if (inflight && inflight.abort) inflight.abort();
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    inflight = ctrl;
    fetch(PROXY + '/search-live?' + buildParams(false).toString(), {
      headers: { Accept: 'application/json' },
      signal: ctrl && ctrl.signal
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) { adoptFx(data); return render(data); })
      .catch(function (err) { if (err && err.name === 'AbortError') return; renderError(); })
      .then(function () { if (els.loading) els.loading.hidden = true; });
  }

  function cap(s) { return s ? s.charAt(0) + s.slice(1).toLowerCase() : s; }

  // Prices come as SEK (d.price, the pricing chain's currency = the fixed SEK list)
  // + EUR (d.priceEur, ceil-to-10 = the fixed EUR list). The SHOP's base currency is
  // EUR since Sep 2026 (window.vaalbergShopCurrency, set in theme.liquid) and
  // Shopify.currency.rate converts FROM that base to the active currency.
  //   • EUR  → d.priceEur (fixed EUR list, matches the PDP to the euro);
  //   • SEK  → d.price   (fixed SEK list, the designed Swedish price);
  //   • any other market currency (DKK, NOK, PLN…) → Shopify's rate applied to the
  //     amount in the BASE currency, which is how the native product pages price.
  var SHOP_CCY = (window.vaalbergShopCurrency || 'EUR').toUpperCase();
  var FX_SEK_PER_EUR = 11.1; // refreshed from every search-live response (fxSekPerEur)
  function fmtMoney(amount, code) {
    if (amount == null) return '—';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return Math.round(amount) + (code === 'EUR' ? ' €' : (code === 'SEK' ? ' kr' : ' ' + code));
    }
  }
  function baseAmount(d) { return SHOP_CCY === 'SEK' ? d.price : d.priceEur; }
  function displayPrice(d) {
    var C = (window.Shopify && Shopify.currency) || {};
    var active = C.active || SHOP_CCY;
    if (active === 'EUR' && d.priceEur != null) return fmtMoney(d.priceEur, 'EUR');
    if (active === 'SEK' && d.price != null) return fmtMoney(d.price, 'SEK');
    var rate = parseFloat(C.rate); // base → active presentment currency
    var base = baseAmount(d);
    if (isFinite(rate) && rate > 0 && base != null) return fmtMoney(Math.round(base * rate), active);
    return fmtMoney(base, SHOP_CCY); // safe fallback: base currency
  }

  // The price FILTER works internally in SEK (so the query + shareable URL stay
  // currency-independent); inputs, placeholders and label show the visitor's active
  // currency. SEK → active goes through the base: SEK / fx = EUR, × Shopify's rate.
  function activeCode() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || SHOP_CCY; }
  function activeRate() {
    var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
    return (isFinite(r) && r > 0) ? r : 1; // base → active
  }
  function sekPerActive() { // how many SEK one unit of the active currency is worth
    var code = activeCode();
    if (code === 'SEK') return 1;
    if (SHOP_CCY === 'SEK') return 1 / activeRate();
    return FX_SEK_PER_EUR / activeRate(); // base is EUR: active = EUR × rate
  }
  function sekToActive(sek) { if (sek == null || !isFinite(sek)) return null; return Math.round(sek / sekPerActive()); }
  function activeToSek(v) { var n = parseFloat(v); if (!isFinite(n)) return null; return Math.round(n * sekPerActive()); }
  function adoptFx(payload) {
    var fx = payload && parseFloat(payload.fxSekPerEur);
    if (isFinite(fx) && fx > 0 && Math.abs(fx - FX_SEK_PER_EUR) > 1e-6) {
      FX_SEK_PER_EUR = fx;
      // re-show the price inputs with the exact rate (they were bound with the default)
      if (els.priceMin && state.priceMin != null) els.priceMin.value = sekToActive(state.priceMin);
      if (els.priceMax && state.priceMax != null) els.priceMax.value = sekToActive(state.priceMax);
    }
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }


  // Heart control. Saved diamonds live in localStorage (diamond-wishlist.js);
  // we only emit the button + a snapshot of the stone so the saved page can
  // render it without another API call.
  function wishBtn(d) {
    if (!d.url) return '';   // only stones that already have a page can be saved
    var payload = {
      url: productUrl(d.url),
      title: [(typeof d.carat === 'number' ? d.carat.toFixed(2) : d.carat) + 'ct', cap(d.shape), 'Diamond'].filter(Boolean).join(' '),
      image: d.image || '',
      priceText: displayPrice(d),
      carat: (typeof d.carat === 'number' ? d.carat.toFixed(2) : d.carat) + ' ct',
      color: d.color || '',
      clarity: d.clarity || ''
    };
    return '<button type="button" class="wish" data-wish data-wish-url="' + esc(payload.url)
      + '" data-wish-payload="' + esc(JSON.stringify(payload)) + '" aria-pressed="false" aria-label="Save this diamond">'
      + '<svg class="wish__off" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99466 4.27984C8.32849 2.332 5.55012 1.80804 3.46257 3.59168C1.37503 5.37532 1.08113 8.3575 2.72049 10.467C4.08351 12.2209 8.20847 15.9201 9.56041 17.1173C9.71166 17.2513 9.78733 17.3183 9.87549 17.3446C9.95249 17.3676 10.0367 17.3676 10.1137 17.3446C10.2019 17.3183 10.2776 17.2513 10.4288 17.1173C11.7807 15.9201 15.9057 12.2209 17.2687 10.467C18.9081 8.3575 18.6501 5.35656 16.5267 3.59168C14.4032 1.8268 11.6607 2.332 9.99466 4.27984Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="wish__on" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99466 4.27984C8.32849 2.332 5.55012 1.80804 3.46257 3.59168C1.37503 5.37532 1.08113 8.3575 2.72049 10.467C4.08351 12.2209 8.20847 15.9201 9.56041 17.1173C9.71166 17.2513 9.78733 17.3183 9.87549 17.3446C9.95249 17.3676 10.0367 17.3676 10.1137 17.3446C10.2019 17.3183 10.2776 17.2513 10.4288 17.1173C11.7807 15.9201 15.9057 12.2209 17.2687 10.467C18.9081 8.3575 18.6501 5.35656 16.5267 3.59168C14.4032 1.8268 11.6607 2.332 9.99466 4.27984Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  }

  function card(d) {
    var caratNum = (typeof d.carat === 'number') ? d.carat : parseFloat(d.carat);
    var caratTxt = isNaN(caratNum) ? '' : caratNum.toFixed(2) + 'ct';
    var media = d.image
      ? '<img loading="lazy" decoding="async" src="' + esc(d.image) + '" alt="' + esc(cap(d.shape) + ' lab diamond ' + caratTxt) + '">'
      : '<div class="dsr__noimg" aria-hidden="true">◇</div>';
    var specs = [caratTxt, cap(d.shape), d.color, d.clarity, d.cut].filter(Boolean).map(esc).join(' · ');
    var inner = '<div class="dsr__media">' + media + (d.lab ? '<span class="dsr__cert">' + esc(d.lab) + '</span>' : '') + '</div>'
      + '<div class="dsr__specs">' + specs + '</div>'
      + '<div class="dsr__price">' + esc(displayPrice(d)) + '</div>';
    // Stones with a page link straight to it; the rest materialise on click
    // (the bridge creates the product for that exact stone, then we redirect).
    if (d.url) return '<a class="dsr__card" href="' + esc(productUrl(d.url)) + '">' + inner + wishBtn(d) + '</a>';
    return '<div class="dsr__card dsr__card--order" role="button" tabindex="0" data-stone="' + esc(d.diamondId || '') + '">'
      + inner + '<span class="dsr__order" data-order-label>View &amp; order →</span></div>';
  }

  // List row — deliberately emits the SAME markup and class names as the
  // collection list (snippets/diamond-row.liquid): img · Shape · Carat · Colour ·
  // Clarity · Cut · Cert · Price · ♡ (or an empty status cell on click-to-order rows,
  // which only shows text such as "Just sold" when materialising fails). The .dlist/.drow rules in
  // diamond-collection.css are self-contained (nothing depends on a .dcol
  // parent), so loading that stylesheet here gives pixel parity for free and
  // keeps the two views from drifting apart later.
  //
  // Stones we have not published yet render as a <div> carrying data-stone, so
  // the existing click handler still materialises them on demand.
  function row(d) {
    var caratNum = (typeof d.carat === 'number') ? d.carat : parseFloat(d.carat);
    // Match the collection's "3 ct" vs "3.01 ct" formatting.
    var caratTxt = isNaN(caratNum)
      ? ''
      : (Math.round(caratNum) === caratNum ? String(Math.round(caratNum)) : caratNum.toFixed(2)) + ' ct';

    var thumb = d.image
      ? '<img class="drow__img" loading="lazy" decoding="async" width="88" height="88" src="' + esc(d.image) + '" alt="">'
      : '<span class="drow__img drow__img--placeholder" aria-hidden="true">◇</span>';

    var inner = thumb
      + '<span class="drow__shape">' + esc(cap(d.shape)) + '<small>Lab grown</small></span>'
      + '<span class="drow__val">' + esc(caratTxt) + '</span>'
      + '<span class="drow__val">' + esc(d.color || '—') + '</span>'
      + '<span class="drow__val">' + esc(d.clarity || '—') + '</span>'
      + '<span class="drow__muted dlist__col--cut">' + esc(d.cut || '—') + '</span>'
      + '<span class="drow__muted dlist__col--cert">' + esc(d.lab || '—') + '</span>'
      + '<span class="drow__price">' + esc(displayPrice(d)) + '</span>';

    if (d.url) {
      return '<a class="drow" href="' + esc(productUrl(d.url)) + '">' + inner + wishBtn(d) + '</a>';
    }
    return '<div class="drow drow--order" role="button" tabindex="0" data-stone="' + esc(d.diamondId || '') + '">'
      + inner + '<span class="drow__status" data-order-label aria-live="polite"></span></div>';
  }

  // Column header, shown only in list view (grid view has no columns).
  function listHead() {
    return '<div class="dlist__head" aria-hidden="true">'
      + '<span></span><span>Shape</span><span>Carat</span><span>Colour</span><span>Clarity</span>'
      + '<span class="dlist__col--cut">Cut</span><span class="dlist__col--cert">Cert</span>'
      + '<span style="text-align:right">Price</span><span></span></div>';
  }

  function facetKey(dim) { return dim === 'fluor' ? 'fluorescence' : dim; }

  function renderFacet(dim, values) {
    var box = els.facets[dim];
    if (!box) return;
    if (!values || !values.length) { box.innerHTML = '<span class="dsf__none">—</span>'; return; }
    box.innerHTML = values.map(function (v) {
      var on = state[dim].indexOf(v.value) > -1;
      var lab = dim === 'shape' ? cap(v.value) : v.value;
      return '<button type="button" class="dsf__chip' + (on ? ' is-on' : '') + '" data-dim="' + dim + '" data-val="' + esc(v.value) + '">'
        + esc(lab) + ' <span class="dsf__n">' + v.count + '</span></button>';
    }).join('');
  }

  function setPlaceholder(el, v, round) {
    if (el && v != null) el.placeholder = round ? Math[round](v) : v;
  }

  function renderPagination(page, pages) {
    if (!els.pagination) return;
    if (!pages || pages <= 1) { els.pagination.innerHTML = ''; return; }
    els.pagination.innerHTML =
      '<button type="button" class="dsp__btn" data-page="' + (page - 1) + '"' + (page <= 1 ? ' disabled' : '') + '>‹ Prev</button>'
      + '<span class="dsp__info">Page ' + page + ' of ' + pages + '</span>'
      + '<button type="button" class="dsp__btn" data-page="' + (page + 1) + '"' + (page >= pages ? ' disabled' : '') + '>Next ›</button>';
  }

  var lastData = null;
  function render(data) {
    lastData = data;
    var isList = state.view === 'list';
    els.results.className = isList ? 'dlist' : 'dsearch__grid'; // also clears is-filtering
    if (els.count) els.count.textContent = data.total.toLocaleString() + ' diamond' + (data.total === 1 ? '' : 's');
    if (!data.results.length) {
      els.results.innerHTML = '';
      if (els.empty) els.empty.hidden = false;
    } else {
      if (els.empty) els.empty.hidden = true;
      els.results.innerHTML = (isList ? listHead() : '') + data.results.map(isList ? row : card).join('');
    }
    // echo the count into the mobile "Show results" apply button
    root.querySelectorAll('[data-count-echo]').forEach(function (el) { el.textContent = data.total.toLocaleString(); });
    MULTI.forEach(function (dim) { renderFacet(dim, data.facets[facetKey(dim)]); });
    if (data.bounds) {
      setPlaceholder(els.caratMin, data.bounds.caratMin);
      setPlaceholder(els.caratMax, data.bounds.caratMax);
      setPlaceholder(els.priceMin, sekToActive(data.bounds.priceMin), 'floor');
      setPlaceholder(els.priceMax, sekToActive(data.bounds.priceMax), 'ceil');
    }
    renderPagination(data.page, data.pages);
    openDeepLink();
  }

  function renderError() {
    // Reset the whole surface, not just the list: the count stayed on its
    // server-rendered "Loading…", the empty-state could show alongside the error,
    // and the pagination buttons stayed live and re-fired the failing request.
    if (els.results) { els.results.className = 'dlist'; els.results.innerHTML =
      '<p class="dsr__error">Search is temporarily unavailable. <a href="' + productUrl('/collections/diamonds') + '">Browse all diamonds →</a></p>'; }
    if (els.count) els.count.textContent = 'Search unavailable';
    if (els.empty) els.empty.hidden = true;
    if (els.pagination) els.pagination.innerHTML = '';
    if (els.loading) els.loading.hidden = true;
  }

  // ---- view toggle (grid ↔ list) ----
  function syncViewButtons() {
    root.querySelectorAll('[data-view]').forEach(function (b) {
      var on = b.getAttribute('data-view') === state.view;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // ---- click-to-order: materialise an exact stone into a real product ----
  // Creation takes ~10s, so a full-page overlay reassures the shopper while
  // the product is being prepared.
  var prepOverlay = null;
  function showPreparing() {
    if (prepOverlay) return;
    prepOverlay = document.createElement('div');
    prepOverlay.className = 'dprep';
    prepOverlay.setAttribute('role', 'status');
    prepOverlay.innerHTML =
      '<div class="dprep__card">'
      + '<span class="dprep__gem" aria-hidden="true">◇</span>'
      + '<p class="dprep__title">Give us a few seconds…</p>'
      + '<p class="dprep__sub">We’re preparing your diamond — its certificate, photos and price.</p>'
      + '</div>';
    document.body.appendChild(prepOverlay);
  }
  function hidePreparing() {
    if (prepOverlay) { prepOverlay.remove(); prepOverlay = null; }
  }

  function materialize(el) {
    if (el.dataset.busy) return;
    var id = el.getAttribute('data-stone');
    if (!id) return;
    el.dataset.busy = '1';
    el.classList.add('is-loading');
    showPreparing();
    var label = el.querySelector('[data-order-label]');
    fetch(PROXY + '/stone?id=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.url) { location.href = productUrl(res.j.url); return; }
        hidePreparing();
        el.classList.remove('is-loading');
        delete el.dataset.busy;
        if (label) label.textContent = (res.j && res.j.error === 'unavailable') ? 'Just sold' : 'Try again';
      })
      .catch(function () {
        hidePreparing();
        el.classList.remove('is-loading');
        delete el.dataset.busy;
        if (label) label.textContent = 'Try again';
      });
  }

  // Click-to-order rows open the instant quick-view panel; the product is created
  // behind it. The blocking overlay above stays only as a fallback for pages that
  // do not load diamond-quickview.js.
  // Seconds a panel must stay open before the product is created in the background
  // (data-qv-dwell on the root, default 2). Lower = ready sooner, more products created.
  var QV_DWELL = (function () { var v = parseFloat(root.getAttribute('data-qv-dwell')); return isNaN(v) ? 2000 : Math.max(0, v * 1000); })();
  function stoneData(id) {
    var list = (lastData && lastData.results) || [];
    for (var i = 0; i < list.length; i++) if (list[i].diamondId === id) return list[i];
    return null;
  }
  function openStone(el) {
    var d = stoneData(el.getAttribute('data-stone'));
    if (window.vaalbergQuickview && d) {
      window.vaalbergQuickview.open(d, { proxy: PROXY, priceText: displayPrice(d), trigger: el, dwell: QV_DWELL });
      return;
    }
    materialize(el);
  }
  // Deep link / Back from the PDP: reopen the panel for ?stone=<id> once results exist.
  var deepLinkDone = false;
  function openDeepLink() {
    if (deepLinkDone || !window.vaalbergQuickview) return;
    deepLinkDone = true;
    var id = new URLSearchParams(location.search).get('stone');
    if (!id) return;
    var d = stoneData(id);
    if (d && !d.url) {
      var el = root.querySelector('[data-stone="' + id.replace(/[^0-9a-f-]/gi, '') + '"]');
      window.vaalbergQuickview.open(d, { proxy: PROXY, priceText: displayPrice(d), trigger: el, push: false, dwell: QV_DWELL });
    } else {
      window.vaalbergQuickview.openById(id, { proxy: PROXY, formatPrice: displayPrice });
    }
  }

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var stone = e.target.closest && e.target.closest('[data-stone]');
    if (stone) openStone(stone);
  });

  // ---- mobile filters: inline expanding panel (like the collection pages) ----
  function setFilters(open) {
    if (!els.filters) return;
    els.filters.classList.toggle('is-open', open);
    if (els.toggle) els.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // closing (via ✕ or "Show results") on mobile → jump back to the results
    if (!open && window.innerWidth <= 800) {
      var main = root.querySelector('.dsearch__main');
      if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ---- events ----
  root.addEventListener('click', function (e) {
    var stone = e.target.closest && e.target.closest('[data-stone]');
    if (stone) { openStone(stone); return; }
    var viewBtn = e.target.closest && e.target.closest('[data-view]');
    if (viewBtn) {
      var vv = viewBtn.getAttribute('data-view');
      if (vv !== state.view) {
        state.view = vv;
        syncViewButtons();
        writeURL();
        if (lastData) render(lastData); // re-render current data, no refetch
      }
      return;
    }
    var chip = e.target.closest && e.target.closest('.dsf__chip');
    if (chip) {
      var dim = chip.getAttribute('data-dim'), val = chip.getAttribute('data-val');
      var i = state[dim].indexOf(val);
      if (i > -1) state[dim].splice(i, 1); else state[dim].push(val);
      chip.classList.toggle('is-on', i === -1); // instant visual state
      state.page = 1; scheduleLoad(); return;
    }
    var pg = e.target.closest && e.target.closest('.dsp__btn');
    if (pg && !pg.disabled) {
      state.page = parseInt(pg.getAttribute('data-page'), 10) || 1;
      load();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var reset = e.target.closest && e.target.closest('[data-reset]');
    if (reset) {
      MULTI.forEach(function (d) { var v = PRESET.get(d); state[d] = v ? v.split(',').filter(Boolean) : []; });
      RANGE.forEach(function (k) { var v = PRESET.get(k); state[k] = (v !== null && v !== '') ? v : null; });
      [els.priceMin, els.priceMax].forEach(function (el) { if (el) el.value = ''; });
      resetCaratSlider();
      state.page = 1; load(); return;
    }
    var tog = e.target.closest && e.target.closest('[data-filter-toggle]');
    if (tog && els.filters) {
      setFilters(!els.filters.classList.contains('is-open'));
    }
  });

  if (els.sort) { els.sort.value = state.sort; els.sort.addEventListener('change', function () { state.sort = els.sort.value; state.page = 1; load(); }); }

  // 'change' on a number input only fires on blur or Enter, so a shopper who typed a
  // value and kept looking at the list saw nothing happen — reported as "the filters
  // don't work". Listen to 'input' too; scheduleLoad debounces and aborts in-flight
  // requests, so typing 4000 is still one search.
  function bindNum(el, key) {
    if (!el) return;
    if (state[key] != null) el.value = state[key];
    var apply = function () { state[key] = el.value !== '' ? el.value : null; state.page = 1; scheduleLoad(); };
    el.addEventListener('change', apply);
    el.addEventListener('input', apply);
  }
  bindNum(els.caratMin, 'caratMin'); bindNum(els.caratMax, 'caratMax'); // no-ops if inputs absent

  // Price inputs are shown/typed in the ACTIVE currency but stored as SEK.
  function bindPrice(el, key) {
    if (!el) return;
    if (state[key] != null) el.value = sekToActive(state[key]); // SEK state → active display
    var apply = function () {
      state[key] = el.value !== '' ? activeToSek(el.value) : null; // active input → SEK state
      state.page = 1; scheduleLoad();
    };
    el.addEventListener('change', apply);
    el.addEventListener('input', apply);
  }
  bindPrice(els.priceMin, 'priceMin'); bindPrice(els.priceMax, 'priceMax');

  // Reflect the active currency in the price filter label (server-rendered as SEK).
  root.querySelectorAll('[data-price-currency]').forEach(function (el) { el.textContent = activeCode(); });

  // ---- carat range slider (dual diamond thumbs), same UX as the collections.
  // Fixed on-brand bounds 0.3–10ct (search-live has no per-query carat bounds).
  var resetCaratSlider = function () {};
  (function initCaratSlider() {
    var crMin = root.querySelector('[data-crange-min]');
    var crMax = root.querySelector('[data-crange-max]');
    if (!crMin || !crMax) return;
    var crFill = root.querySelector('[data-crange-fill]');
    var crLo = root.querySelector('[data-crange-lo]');
    var crHi = root.querySelector('[data-crange-hi]');
    var LO = 0.3, HI = 10;
    function label(n) { return (Math.round(n * 10) / 10) + ' ct'; }
    [crMin, crMax].forEach(function (i) { i.min = LO; i.max = HI; i.step = 0.1; });
    crMin.value = (state.caratMin != null) ? Math.max(LO, parseFloat(state.caratMin)) : LO;
    crMax.value = (state.caratMax != null) ? Math.min(HI, parseFloat(state.caratMax)) : HI;
    function sync(moved) {
      var a = parseFloat(crMin.value), b = parseFloat(crMax.value);
      if (a > b) { if (moved === crMin) { crMax.value = crMin.value; b = a; } else { crMin.value = crMax.value; a = b; } }
      var span = HI - LO || 1;
      if (crFill) { crFill.style.left = ((a - LO) / span * 100) + '%'; crFill.style.right = (100 - (b - LO) / span * 100) + '%'; }
      if (crLo) crLo.textContent = label(a);
      if (crHi) crHi.textContent = label(b);
      crMin.style.zIndex = a > (LO + HI) / 2 ? 4 : 3;
      state.caratMin = a > LO ? String(a) : null;
      state.caratMax = b < HI ? String(b) : null;
    }
    crMin.addEventListener('input', function () { sync(crMin); state.page = 1; scheduleLoad(); });
    crMax.addEventListener('input', function () { sync(crMax); state.page = 1; scheduleLoad(); });
    resetCaratSlider = function () { crMin.value = LO; crMax.value = HI; sync(crMin); };
    sync(crMin);
  })();

  syncViewButtons();
  load();
})();
